export class UploadGym {
  lng: number | null = null;
  lat: number | null = null;
}
